import React, { Component } from 'react';
import { connect } from 'react-redux'
import styles from "./styles.module.css";
import mexico from '../../assets/nav/mexico.png';
import usa from '../../assets/nav/usa.png';
import { LanguageActions } from '../../redux/language';
import spanish from '../../common/language/spanis';
import english from '../../common/language/english';
import layout from '../../common/layout'
import { Link } from "react-scroll";

let lang = spanish;

class Head extends Component {
    //Change State to Show List also,  triggers a change in the route

    componentWillReceiveProps(next) {
        // console.log(next);
        if (next.language === 'spanish') {
            lang = spanish;
        }
        else {
            lang = english;
        }
    }

    handleLanguage = (language) => {
        const { setCurrentLanguage } = this.props;
        setCurrentLanguage(language);
    }

    render() {
        return (
            <div className={styles.backNav}>
                <nav className={styles.nav}>
                    <ul className={styles.containerNav}>
                        <li className={styles.title} style={{ color: layout.gold }}>Grand Puesta Dorada</li>
                        <li className={styles.containerOptions} >
                        <Link
                                to="about"
                                spy={true}
                                smooth={true}
                                hashSpy={true}
                                offset={50}
                                duration={500}
                                delay={100}
                                isDynamic={true}
                                onSetActive={this.handleSetActive}
                                onSetInactive={this.handleSetInactive}
                                ignoreCancelEvents={false}
                            >
                                <div className="linkTop">
                                    {lang.nav.about}
                                </div>
                            </Link>
                            <div>
                            </div>
                            <Link
                                to="cruises"
                                spy={true}
                                smooth={true}
                                hashSpy={true}
                                offset={50}
                                duration={500}
                                delay={100}
                                isDynamic={true}
                                onSetActive={this.handleSetActive}
                                onSetInactive={this.handleSetInactive}
                                ignoreCancelEvents={false}
                            >
                                <div className="linkTop">
                                    {lang.nav.cruisers}
                                </div>
                            </Link>
                            <div>
                            </div>
                            <Link
                                to="resorts"
                                spy={true}
                                smooth={true}
                                hashSpy={true}
                                offset={50}
                                duration={500}
                                delay={100}
                                isDynamic={true}
                                onSetActive={this.handleSetActive}
                                onSetInactive={this.handleSetInactive}
                                ignoreCancelEvents={false}
                            >
                                <div className="linkTop">
                                    {lang.nav.hotels}
                                </div>
                            </Link>
                        </li>
                        <li className={styles.containerContacta} style={{ color: layout.gold }}>
                            <div>
                                +(521) 442-174-6482
                            </div>
                        </li>
                        <li
                            style={{ position: 'absolute', right: 50 }}
                            onClick={() => { this.handleLanguage('spanish') }}
                        >
                            <img alt="mex" src={mexico} className={styles.flag} />
                        </li>
                        <li
                            style={{ position: 'absolute', right: 0 }}
                            onClick={() => { this.handleLanguage('english') }}
                        >
                            <img alt="usa" src={usa} className={styles.flag} />
                        </li>
                    </ul>
                </nav>

            </div>
        );
    }
}

const mapStateToProps = state => ({
    language: state.LanguageReducer.language,
});

const mapDispatchToProps = dispatch => ({
    setCurrentLanguage: (language) => {
        dispatch(LanguageActions.setLanguage(language));
    },
});

// make this component available to the app
export default connect(mapStateToProps, mapDispatchToProps)(Head);


